import { makeStyles } from '@material-ui/core';
import Logo from '../../assets/images/olimpia-logo.svg';

const useStyles = makeStyles({
  container: {
    width: 'auto',
    height: 30,
    display: 'flex',
    gap: '16px',
    fontSize: 20.16,
    fontWeight: 600,
    color: '#fff'
  },
});

const LogoFull = () => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <img src={Logo} />
      <span>
        PORTAL OLIMPIA
      </span>
    </div>
  );
};

export default LogoFull;
